import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { AuthGuard } from './auth.guard';
import { FeatureAccessGuard } from './common/guard/feature-access.guard';
import { HomeComponent } from './home/home.component';
import { HomeResolver } from './home/home.resolver';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        canActivate: [AuthGuard],
        resolve: { home: HomeResolver },
        children: [
            {
                path: '',
                loadChildren: () => import('./dashboard/dashboard.module').then(mod => mod.DashboardModule)
            },
            {
                path: 'my-accounts',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./dashboard/dashboard.module').then(mod => mod.DashboardModule)
            },
            {
                path: 'inquiry/summary',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./inquiry/summary/summary.module').then(mod => mod.SummaryModule)
            },
            {
                path: 'inquiry/statement',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./inquiry/statement/statement.module').then(mod => mod.StatementModule)
            },
            {
                path: 'inquiry/mini-statement',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./inquiry/mini-statement/mini-statement.module').then(mod => mod.MiniStatementModule)
            },
            {
                path: 'history/transfer-history',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./inquiry/transfer-history/transfer-history.module').then(mod => mod.TransferHistoryModule)
            },
            {
                path: 'transfer/at-my-bank',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./transfer/at-my-bank/at-my-bank.module').then(mod => mod.AtMyBankModule)
            },
            {
                path: 'transfer/beftn',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./transfer/beftn/beftn.module').then(mod => mod.BeftnModule)
            },
            {
                path: 'transfer/beftnCard',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./transfer/beftn-card/beftn-card.module').then(mod => mod.BeftnCardModule)
            },
            {
                path: 'transfer/otherBankAccount',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./transfer/npsb-account/npsb-account.module').then(mod => mod.NpsbAccountModule)
            },
            {
                path: 'transfer/otherBankCard',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./transfer/npsb-card/npsb-card.module').then(mod => mod.NpsbCardModule)
            },
            {
                path: 'transfer/beneficiary-management',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./transfer/beneficiary-management/beneficiary-management.module').then(mod => mod.BeneficiaryManagementModule)
            },
            {
                path: 'transfer/pending-list',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./transfer/pending-list/pending-list.module').then(mod => mod.PendingListModule)
            },
            {
                path: 'change-password',
                loadChildren: () => import('./change-password/change-password.module').then(mod => mod.ChangePasswordModule)
            },
            {
                path: 'my-profile',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./my-profile/my-profile.module').then(mod => mod.MyProfileModule)
            },
            {
                path: 'branch-locator',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./branch-locator/branch-locator.module').then(mod => mod.BranchLocatorModule)
            },
            // {
            //     path: 'cheque-book-request-link',
            //     canActivate: [FeatureAccessGuard],
            //     redirectTo: 'cheque-service/request-new-cheque-book',
            //     pathMatch: 'full'
            // },
            {
                path: 'branch-locator-map',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./branch-locator-map/branch-locator-map.module').then(mod => mod.BranchLocatorMapModule)
            },
            {
                path: 'emi-calculator',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./emi-calculator/emi-calculator.module').then(mod => mod.EmiCalculatorModule)
            },
            {
                path: 'advance-loan-calculator',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./advance-loan-calculator/advance-loan-calculator.module').then(mod => mod.AdvanceLoanCalculatorModule)
            },
            {
                path: 'faq',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./FAQ/FAQ.module').then(mod => mod.FAQModule)
            },
            {
                path: 'support',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./support/support.module').then(mod => mod.SupportModule)
            },
            {
                path: 'mobile-recharge',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./top-up/recharge/recharge.module').then(mod => mod.RechargeModule)
            },
            {
                path: 'recharge-beneficiary',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./top-up/recharge-beneficiary/recharge-beneficiary.module').then(mod => mod.RechargeBeneficiaryModule)
            },
            {
                path: 'recharge-pending-transaction',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./top-up/recharge-pending-transaction/recharge-pending-transaction.module').then(mod => mod.RechargePendingTransactionModule)
            },
            {
                path: 'add-nagad-money',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./nagad/nagad-add-money/nagad-add-money.module').then(mod => mod.NagadAddMoneyModule)
            },
            {
                path: 'add-nagad-beneficiary',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./nagad/nagad-beneficiary-management/nagad-beneficiary-management.module').then(mod => mod.NagadBeneficiaryManagementModule)
            },
            {
                path: 'pending-transaction',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./nagad/pending-transaction/pending-transaction.module').then(mod => mod.PendingTransactionModule)
            },
            {
                path: 'bkash-add-money',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./bkash/bkash-add-money/bkash-add-money.module').then(mod => mod.BkashAddMoneyModule)
            },
            {
                path: 'bkash-beneficiary-management',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./bkash/bkash-beneficiary-management/bkash-beneficiary-management.module').then(mod => mod.BkashBeneficiaryManagementModule)
            },
            {
                path: 'bkash-pending-transaction',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./bkash/bkash-pending-transaction/bkash-pending-transaction.module').then(mod => mod.BkashPendingTransactionModule)
            },
            {
                path: 'pay-fee',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./education-fee/fee-pay/fee-pay.module').then(mod => mod.FeePayModule)
            },
            {
                path: 'education-fee-history',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./education-fee/education-fee-history/education-fee-history.module').then(mod => mod.EducationFeeHistoryModule)
            },
            {
                path: 'fetch-bill-details',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./education-fee/fetch-bill-details/fetch-bill-details.module').then(mod => mod.FetchBillDetailsModule)
            },
            {
                path: 'fee-pre-process',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./education-fee/education-fee-pre-process/education-fee-pre-process.module').then(mod => mod.EducationFeePreProcessModule)
            },
            {
                path: 'pending-payment-history',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./education-fee/education-pending-fee/education-pending-fee.module').then(mod => mod.EducationPendingFeeModule)
            },
            {
                path: 'bills',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./bill-pay/bill-pay.module').then(module => module.BillPayModule)
            },
            {
                path: 'exchange-rate',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./exchange-rate/exchange-rate.module').then(mod => mod.ExchangeRateModule)
            },
            {
                path: 'npsb-dispute',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./npsb-dispute/npsb-dispute.module').then(m => m.NpsbDisputeModule)
            },
            {
                path: 'user-activity',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./inquiry/user-activity/user-activity.module').then(mod => mod.UserActivityModule)
            },
            {
                path: 'transfer/transaction-status-inquiry',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./inquiry/transaction-status-inquiry/transaction-status-inquiry.module').then(mod => mod.TransactionStatusInquiryModule)
            },
            {
                path: 'transaction-limit',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./inquiry/transaction-limit/transaction-limit.module').then(mod => mod.TransactionLimitModule)
            },
            {
                path: 'cheque-service',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./cheque-service/cheque-service.module').then(mod => mod.ChequeServiceModule)
            },
            {
                path: 'self-service',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./self-service/self-service.module').then(mod => mod.SelfServiceModule)
            },
            {
                path: 'standing-instructions',
                canActivate: [FeatureAccessGuard],
                loadChildren: () => import('./standing-instructions/standing-instructions.module').then(mod => mod.StandingInstructionsModule)
            }
        ]
    },
    {
        path: 'login',
        children: [
            { path: '', component: LoginComponent }
            //,{
            //    path: 'otp',
            //    loadChildren: () => import('./login/otp/otp.module').then(mod => mod.OtpModule)
            //}
        ]
    },
    {
        path: 'forgot-userid-password',
        loadChildren: () => import('./forgot-userid-password/forgot-userid-password.module').then(mod => mod.ForgotUseridPasswordModule)
    },
    // {
    //     path: 'support', loadChildren: () => import('./support/support.module').then(mod => mod.SupportModule)
    // },
    {
        path: 'registration',
        loadChildren: () => import('./registration/registration.module').then(mod => mod.RegistrationModule)
    },
    {
        path: 'open-bank-account',
        loadChildren: () => import('./open-bank-account/open-bank-account.module').then(mod => mod.OpenBankAccountModule)
    },
    {
        path: 'set-password',
        loadChildren: () => import('./set-password/set-password.module').then(mod => mod.SetPasswordModule)
    },
    {
        path: 'session-expired',
        loadChildren: () => import('./session-expired/session-expired.module').then(mod => mod.SessionExpiredModule)
    },
    {
        path: 'page-not-found',
        loadChildren: () => import('./page-not-found/page-not-found.module').then(mod => mod.PageNotFoundModule)
    },
    {
        path: '**',
        redirectTo: '/page-not-found'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
